import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'logistics_waybill_order_page',
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '运单',
        queryFunName: 'logisticHongdeWaybillOrderQuery',
        detailOrderFunName: 'logisticHongdeWaybillOrderDetail',
        detailFunName: 'logisticHongdeWaybillDetail',
        dicTreeFunName: 'mngDictionaryLowerTree',
        totalFeeFunName: 'logisticHongdeWaybillOrderFeeTotal',
        carTeamAllFunName: 'logisticHongdeCarTeamQueryAll',
        shipCompanyDetailFunName: 'logisticHongdeShipCompanyDetail',
        driverDetailFunName: 'logisticHongdeDriverDetail'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time',
        dateType: 'Create',
        merchantNickname: null,
        waybillDeliveryMode: null,
        starDate: null,
        endDate: null,
        orderState: null,
        driverName: null,
        driverContactPhone: null,
        carTeamName: null,
        merchantContactPhone: null,
        waybillExtractIdentity: null
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      detailDialogShow: false,
      formLabelWidth: '100px',
      waybillDetailData: {
        id: null,
        cradleAddress: null,
        cradleLbs: null,
        cradleBeginTime: null,
        cradleLastTime: null,
        assembleAddress: null,
        assembleLbs: null,
        assembleBeginTime: null,
        assembleLastTime: null,
        purposeAddress: null,
        purposeLbs: null,
        purposeBeginTime: null,
        purposeLastTime: null,
        shipCompanyId: null,
        shipRemark: null
      },
      waybillOrderDetailData: {
        driverName: null,
        driverContactPhone: null,
        driverCarNumber: null,
        firstContainerIdentity: null,
        firstContainerSealIdentity: null,
        secondContainerIdentity: null,
        secondContainerSealIdentity: null,
        merchantContactPhone: null,
        waybillContainerSize: null,
        waybillContainerShape: null,
        waybillContainerFullRequire: null,
        waybillContainerWeightRange: null,
        waybillDeliveryMode: null,
        serviceFeeScale: null
      },
      dicData: {
        sizeUpperCode: 'logistics_hd_container_size',
        configSizes: [],
        configSizeOptions: {},
        shapeUpperCode: 'logistics_hd_container_shape',
        configShapes: [],
        configShapeOptions: {}
      },
      totalFeeFormData: {
        freightCost: null,
        serviceFeeCost: null
      },
      carTeamData: {
        configCarTeams: [],
        configCarTeamOptions: {}
      },
      driverDetailData: {
        carNumber: null,
        name: null,
        contactPhone: null
      },
      orderState: {
        Wait: {
          label: '待接单',
          value: 'Wait'
        },
        Accept: {
          label: '已接单',
          value: 'Accept'
        },
        First_Place_Confirm: {
          label: '提箱确认',
          value: 'First_Place_Confirm'
        },
        Second_Place_Confirm: {
          label: '卸货/送货确认',
          value: 'Second_Place_Confirm'
        },
        Third_Place_Confirm: {
          label: '收箱确认',
          value: 'Third_Place_Confirm'
        },
        Merchant_Confirm: {
          label: '已结案',
          value: 'Merchant_Confirm'
        },
        Undo: {
          label: '已撤单',
          value: 'Undo'
        },
        Refuse: {
          label: '转单拒绝',
          value: 'Refuse'
        },
        back_address: {
          label: '返箱回提箱地确认',
          value: 'back_address'
        },
        driver_finish: {
          label: '返箱回提箱地完成',
          value: 'driver_finish'
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    Promise.all([new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.sizeUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configSizes = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configSizeOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.shapeUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configShapes = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configShapeOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.carTeamAllFunName]().then(function (res) {
        if (res.data) {
          _this.carTeamData.configCarTeams = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.carTeamData.configCarTeamOptions[res.data[i].id] = res.data[i].name;
          }
        }
        resolve(res);
      });
    })]).then(function (result) {
      _this.query();
    });
  },
  methods: {
    back: function back() {
      this.$emit('child-go-waybill');
    },
    rowDetail: function rowDetail(data) {
      var _this2 = this;
      this.waybillOrderDetailData = data;
      // 司机
      if (data.driverId) {
        this.$api[this.pageConfig.driverDetailFunName](data.driverId).then(function (driverRes) {
          _this2.driverDetailData = driverRes.data;
        });
      }
      this.getDetail(data.waybillId);
      this.detailDialogShow = true;
    },
    query: function query() {
      var _this3 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.processSearchForm()).then(function (res) {
        _this3.tableData = res.data || [];
        _this3.totalCount = res.count;
        _this3.queryLoading = false;
      });
      this.$api[this.pageConfig.totalFeeFunName](this.processSearchForm()).then(function (res) {
        _this3.totalFeeFormData = res.data;
      });
    },
    processSearchForm: function processSearchForm() {
      var commitSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      return commitSearchForm;
    },
    getDetail: function getDetail(id) {
      var _this4 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this4.waybillDetailData = res.data;
        // 船公司
        if (res.data.shipCompanyId) {
          _this4.$api[_this4.pageConfig.shipCompanyDetailFunName](res.data.shipCompanyId).then(function (shipCompanyRes) {
            _this4.waybillDetailData.shipCompanyId = shipCompanyRes.data.code || _this4.waybillDetailData.shipCompanyId;
            _this4.waybillDetailData.shipCompanyName = shipCompanyRes.data.name || '';
            _this4.waybillDetailData.shipRemark = shipCompanyRes.data.remark || '';
          });
        }

        // 车队
        if (res.data.specifyCarTeamIds) {
          var carTeamNames = '';
          var carTeamIdJson = JSON.parse(res.data.specifyCarTeamIds);
          for (var i = 0; i < carTeamIdJson.length; i++) {
            if (i !== 0) {
              carTeamNames += '、';
            }
            carTeamNames += carTeamIdJson[i].name;
          }
          res.data.specifyCarTeamIds = carTeamNames;
        }
        _this4.queryLoading = false;
      });
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    exportData: function exportData() {
      var requestUrl = process.env.VUE_APP_API + 'logistics_hongde/waybillOrder/basisExportJoinWaybillAndDriver';
      var searchParams = this.processSearchForm();
      searchParams.Authorization = localStorage.getItem('token');
      window.open(requestUrl + this.joinGetParam(searchParams), '_blank');
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};